import chroma from 'chroma-js'
import styled, { css } from 'styled-components'

import Icon from '../../../Icon'

export const Container = styled.div<{ $isDisabled: boolean }>`
  opacity: ${(props) => (props.$isDisabled ? 0.4 : 1)};
`

export const Label = styled.label<{ $isDisabled: boolean }>`
  display: flex;
  gap: 20px;
  ${({ theme }) => theme.textStyles.textLarge};
  cursor: ${(props) => (props.$isDisabled ? 'not-allowed' : 'pointer')};
  align-items: center;
`

export const LabelText = styled.div<{ $required: boolean; $isError?: boolean }>`
  & p {
    display: inline;
  }

  & a {
    color: ${({ theme }) => theme.colors.pureBlack};
  }

  ${(props) =>
    props.$required &&
    css`
      &:after {
        content: ' *';
        color: ${(props) => props.theme.colors.darkOrange};
      }
    `}

  ${(props) =>
    props.$isError &&
    css`
      &,
      & a {
        color: ${props.theme.colors.red};
      }
    `}
`

export const Checkbox = styled.input<{ $isError?: boolean }>`
  position: absolute;
  opacity: 0;
`

export const Checkmark = styled.span<{ $isError?: boolean }>`
  position: relative;
  appearance: none;
  width: 2rem;
  height: 2rem;
  margin: 0;
  border-radius: 0.3rem;
  flex-shrink: 0;
  border-width: 2px;
  border-style: solid;
  border-color: ${(props) => props.theme.colors.egyptianBlue};

  ${(props) =>
    props.$isError &&
    css`
      border-color: ${props.theme.colors.red};
    `}

  cursor: pointer;
  input[disabled] ~ & {
    cursor: not-allowed;
  }

  //
  // Checkmark
  //
  &::before {
    content: '';
    display: inline-block;
    width: 100%;
    height: 100%;
    position: absolute;
    top: 50%;
    left: 50%;
    opacity: 0;
    transform: translate(-50%, -50%);
    background-color: ${(props) => props.theme.colors.neonBlue};
  }

  //
  // Hover
  //
  ${(props) => css`
    cursor: pointer;
    &:hover:not(:disabled),
    a:hover &:not(:disabled),
    a:focus-visible &:not(:disabled),
    &:focus-visible:not(:disabled) {
      &::after {
        transform: translate(-50%, -50%) scale(9);
        background-color: ${chroma(props.theme.colors.neonBlue).alpha(0.04).css()};
      }
    }
  `}

  input:checked ~ & {
    ${(props) => css`
      border-color: ${props.theme.colors.neonBlue};
    `}
  }

  input:checked ~ &::before {
    opacity: 1;
  }
`

export const StyledIcon = styled(Icon)`
  height: 100%;
  position: relative;
  z-index: 1;
  opacity: 0;
  color: ${({ theme }) => theme.colors.pureWhite};
  input:checked ~ * & {
    opacity: 1;
  }
`

export const Error = styled.p`
  ${({ theme }) => theme.textStyles.text}
  color: ${({ theme }) => theme.colors.red};
  margin-top: 0.5rem;
`

export const Help = styled.p`
  ${({ theme }) => theme.textStyles.textSmall}
  color: grey;
  margin-top: 0.5rem;
`
